import { createAction, props } from '@ngrx/store';

import { OrderDetailCommands } from '../../domain/commands/order-detail.commands';

import { Order } from '@api/order/order.models';

export const OpenSidebarOrderDetail = createAction(
    OrderDetailCommands.OPEN_SIDEBAR_ONLINE_ORDER,
    props<{ order: Partial<Order>; hasSubOrders: boolean }>()
);

export const OpenSidebarOnlineOrderSuccess = createAction(OrderDetailCommands.OPEN_SIDEBAR_ONLINE_ORDER_SUCCESS);

export const CloseSidebarOnlineOrder = createAction(OrderDetailCommands.CLOSE_SIDEBAR_ONLINE_ORDER);

export const CloseSidebarOnlineOrderSuccess = createAction(OrderDetailCommands.CLOSE_SIDEBAR_ONLINE_SUCCESS);

export const CloseSidebarOnlineOrderError = createAction(
    OrderDetailCommands.CLOSE_SIDEBAR_ONLINE_ERROR,
    props<{ error: any }>()
);

export const CloseSidebarOnlineOrderDueNavigationSuccess = createAction(
    OrderDetailCommands.CLOSE_SIDEBAR_ONLINE_DUE_NAVIGATION
);

export const CloseSidebarOnlineOrderDueNavigationError = createAction(
    OrderDetailCommands.CLOSE_SIDEBAR_ONLINE_DUE_NAVIGATION,
    props<{ error: any }>()
);
